import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit, inject, DestroyRef } from '@angular/core';

import { MenuAction } from '@anecdotes/design-system/dropdown-menu';
import { CommentSortingOption, CommentSortOptionDefinition, SortDirection, ThreadSort } from '../../models';
import { CommentPanelManagerService } from '../../services';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-thread-sorting',
  templateUrl: './thread-state-sorting.component.html',
  styleUrls: ['./thread-state-sorting.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThreadSortingComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  @HostBinding('class')
  private get classes(): string {
    if (!this.isDisabled && this.selectedSortOption) {
      return 'bg-navy-40 rounded-md';
    }
  }

  @Input()
  isDisabled: boolean;

  selectedSortOption: ThreadSort = null;

  readonly sortingMenuActions: MenuAction[] = [
    {
      translationKey: this.buildTranslationKey('sorting.recentActivityOption'),
      action: () => this.changeSortOption(CommentSortingOption.RecentActivityOption),
    },
    {
      translationKey: this.buildTranslationKey('sorting.dateCreatedOption'),
      action: () => this.changeSortOption(CommentSortingOption.DateCreatedOption),
    },
  ];

  constructor(private commentPanelManager: CommentPanelManagerService) {}

  ngOnInit(): void {
    this.commentPanelManager.getSelectedSortOption()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((selectedSortOption: ThreadSort) => this.selectedSortOption = selectedSortOption);

    this.commentPanelManager.getSortOptions()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((sortOptions: CommentSortOptionDefinition[]) => {
        if (sortOptions) {
          const newOptions: MenuAction[] = sortOptions.map((option: CommentSortOptionDefinition) => ({
            translationKey: option.translationKey,
            action: this.changeSortOption.bind(this, option.sortBy),
          }));

          this.sortingMenuActions.unshift(...newOptions);
        }

        this.sortingMenuActions[0].action();
      });
  }

  buildTranslationKey(relativeKey: string): string {
    return `commenting.${relativeKey}`;
  }

  private changeSortOption(field?: string): void {
    let sortOption: ThreadSort = null;

    if (field) {
      sortOption = {
        direction:
          field === this.selectedSortOption?.field && this.selectedSortOption?.direction === SortDirection.DESC
            ? SortDirection.ASC
            : SortDirection.DESC,
        field,
      };
    }

    this.commentPanelManager.changeSortOption(sortOption);
  }
}
